import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

Vue.use(Vuex)

import modules from './modules'


const store = new Vuex.Store({
  state: {
    authUser: null,
    accessToken: null,
    isLockScreen: false
  },
  getters: {
    authenticated: state => state.accessToken !== null,
    accessToken: state => state.accessToken,
  },
  mutations: {
    setAuthUser(state, authUser) {
      if (authUser) {
        state.authUser = Object.assign(
          {},
          {
            user: authUser.user,
            permissions: authUser.permissions,
            sys_setting: authUser.sys_setting
          }
        );
        localStorage.setItem(
          "authUser",
          JSON.stringify(state.authUser)
        );
      } else {
        state.authUser = null;
        localStorage.clear();
      }
      state.accessToken = VueCookies.get("token");
    },
    setIsLock(state, value) {
      state.isLockScreen = value;
      localStorage.setItem("!z_dy#@_____00111$%!@", value);
    }
  },
  actions: {
    init({ commit }) {
      const authUser = JSON.parse(localStorage.getItem('authUser'))
      if (authUser) {
        commit('setAuthUser', authUser)
      }
      commit(
        "setIsLock",
        parseInt(localStorage.getItem("!z_dy#@_____00111$%!@"))
      );
    },
  },
  modules
})

store.dispatch('init')

export default store
